import React from 'react'
import Moment from 'moment'
import Field from './Field.js'

export default props => {

    return <Field type="date" name="date" label="Дата" 
        value={Moment().format('YYYY-MM-DD')} {...props}  />
}